import React from 'react';

const SvgTwitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M14.7857 0H2.21429C1.26786 0 0.5 0.767857 0.5 1.71429V14.2857C0.5 15.2321 1.26786 16 2.21429 16H14.7857C15.7321 16 16.5 15.2321 16.5 14.2857V1.71429C16.5 0.767857 15.7321 0 14.7857 0ZM13.0393 5.67143C13.0464 5.77143 13.0464 5.875 13.0464 5.975C13.0464 9.07143 10.6893 12.6393 6.38214 12.6393C5.05357 12.6393 3.82143 12.2536 2.78571 11.5893C2.975 11.6107 3.15714 11.6179 3.35 11.6179C4.44643 11.6179 5.45357 11.2464 6.25714 10.6179C5.22857 10.5964 4.36429 9.92143 4.06786 8.99286C4.42857 9.04643 4.75357 9.04643 5.125 8.95C4.05357 8.73214 3.25 7.78929 3.25 6.65V6.62143C3.56071 6.79643 3.925 6.90357 4.30714 6.91786C3.98587 6.70415 3.72249 6.41424 3.54053 6.07398C3.35856 5.73373 3.26365 5.35372 3.26429 4.96786C3.26429 4.53214 3.37857 4.13214 3.58214 3.78571C4.73571 5.20714 6.46786 6.13572 8.41071 6.23571C8.07857 4.64643 9.26786 3.35714 10.6964 3.35714C11.3714 3.35714 11.9786 3.63929 12.4071 4.09643C12.9357 3.99643 13.4429 3.8 13.8929 3.53214C13.7179 4.075 13.35 4.53214 12.8643 4.82143C13.3357 4.77143 13.7929 4.63929 14.2143 4.45714C13.8964 4.925 13.4964 5.33929 13.0393 5.67143Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTwitter;
